import { render } from "./PrioritizationSettings.vue?vue&type=template&id=d55faeaa"
import script from "./PrioritizationSettings.vue?vue&type=script&lang=js"
export * from "./PrioritizationSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/settings/user_profile/PrioritizationSettings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d55faeaa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d55faeaa', __exports__)) {
    api.reload('d55faeaa', __exports__)
  }
  
  module.hot.accept("./PrioritizationSettings.vue?vue&type=template&id=d55faeaa", () => {
    api.rerender('d55faeaa', render)
  })

}


export default __exports__